import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { AgGridVue } from "ag-grid-vue";
import { noRowsTemplate } from "@/components/GiftsPage/noRowsTemplate";
import { DashboardService, GiftsService } from "@/services";
import $thousandMask from "@/mixins/thousandMask";
import symbolInTable from "@/components/WalletPage/SymbolInTable/index.vue";
import PricesInTable from "@/components/GiftsPage/PricesInTable";
import PayDateInTable from "@/components/GiftsPage/PayDateInTable";
import dayjs from "dayjs";
import "swiper/dist/css/swiper.min.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "gifts-page",
  components: {
    AgGridVue,
    symbolInTable,
    PricesInTable,
    PayDateInTable,
    swiper,
    swiperSlide
  },
  props: [],
  mixins: [$thousandMask],
  data() {
    return {
      giftInfoBox: null,
      rewardData: null,
      page: 1,
      loading: false,
      gridOptions: null,
      localeText: null,
      giftsTableHeader: null,
      defaultGiftsHeader: null,
      paginationPageSize: 10,
      paginationNumberFormatter: null,
      giftsData: null,
      tableItemShow: [
        { name: "10", value: 10 },
        { name: "20", value: 20 },
        { name: "30", value: 30 }
      ],
      tableItemShowFirstIndex: 10,
      giftTableLoader: true,
      giftCardLoader: true,
      bannersData: null,
      swiperOption: {
        direction: "horizontal",
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 16,
        setWrapperSize: 380,
        autoplay: {
          delay: 4000
        },
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          // when window width is >= 600px
          600: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          800: {
            slidesPerView: 1,
            spaceBetween: 16
          },
          // when window width is >= 960px
          960: {
            slidesPerView: 1,
            spaceBetween: 16
          },
          1025: {
            slidesPerView: 1,
            spaceBetween: 16
          }
        },
        lazy: true,
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        //   disabledClass: "custom"
        // },
        pagination: {
          el: ".banner-slider-pagination",
          clickable: true
        }
      }
    };
  },
  beforeMount() {
    this.localeText = {
      to: this.$t("giftsPage.to"),
      of: this.$t("giftsPage.from")
    };
    this.gridOptions = {
      overlayNoRowsTemplate: noRowsTemplate(this.$t("giftsPage.no_reward_yet"))
    };
    this.giftsTableHeader = [
      {
        colId: 0,
        headerName: this.$t("giftsPage.rowNumber"),
        field: "row_number",
        unSortIcon: true,
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 100,
        maxWidth: 100
      },
      {
        colId: 6,
        headerName: this.$t("giftsPage.date"),
        field: "created_at",
        unSortIcon: true,
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 170,
        cellClass: "ag-grid-date-class"
      },
      {
        colId: 1,
        headerName: this.$t("giftsPage.description"),
        field: "user_description",
        unSortIcon: true,
        suppressSizeToFit: true,
        flex: 2,
        minWidth: 300
      },
      {
        colId: 2,
        headerName: this.$t("giftsPage.symbol"),
        field: "symbol",
        cellRendererFramework: "symbolInTable",
        headerClass: "update-cell-symbol header-table-ag-grid-cell",
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 100
      },
      {
        colId: 3,
        headerName: this.$t("giftsPage.amount"),
        field: "amount",
        // cellRendererFramework: "PricesInTable",
        unSortIcon: true,
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 150,
        cellRenderer: params => {
          return params.value != 0 ? params.value : "-";
        }
      },
      {
        colId: 4,
        headerName: this.$t("giftsPage.BCEQ"),
        field: "BCEQ",
        unSortIcon: true,
        cellRenderer: params => {
          return params.value != 0 ? "USDT " + params.value : "-";
        },
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 180
      },
      {
        colId: 5,
        headerName: this.$t("giftsPage.transactionId"),
        field: "ref_no",
        unSortIcon: true,
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 170
      },
      {
        colId: 7,
        headerName: this.$t("giftsPage.payDate"),
        field: "charged_at",
        unSortIcon: true,
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 170,
        maxWidth: 170,
        cellRendererFramework: "PayDateInTable"
      }
    ];
    this.defaultGiftsHeader = {
      headerClass: "header-table-ag-grid-cell",
      lockPosition: true,
      suppressSizeToFit: true,
      icons: {
        sortUnSort:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#c1c6cd"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#c1c6cd"></path></svg>',
        sortAscending:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#c1c6cd"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#500fe9"></path></svg>',
        sortDescending:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#500fe9"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#c1c6cd"></path></svg>'
      }
    };
    this.paginationPageSize = 10;
    // this.paginationNumberFormatter = params => {
    //   return "[" + params.value.toLocaleString() + "]";
    // };
  },
  computed: {
    setGiftsData() {
      let data = [];
      if (this.giftsData) {
        this.giftsData.data.forEach((elem, index) => {
          data.push({
            row_number: index + 1,
            id: elem.id,
            symbol: { logo: elem.logo, iso: elem.currency_iso },
            ref_no: elem.ref_no,
            BCEQ: this.$thousandMask(elem.BCEQ),
            amount: this.$thousandMask(elem.amount),
            created_at:
              dayjs(elem.created_at).format("mm : HH") +
              " - " +
              dayjs(elem.created_at).format("YYYY/MM/DD"),
            user_description: elem.user_description,
            charged_at: elem.charged_at
            // charged_at: `
            //   ${elem.charged_at ? `<v-icon size="18" clr="var(--v-gray1-base)">$clock</v-icon>` : ''}
            //   ${elem.charged_at ? dayjs(elem.charged_at).format("YYYY/MM/DD") : 'پایان کمپین'}
            // `
          });
        });
      }
      // if (Object.entries(this.giftsData).length > 0) {
      return data;
      // }
    }
  },
  mounted() {
    this.getGifts();
    this.getRewards();
    this.getPage();
    this.getSlider();
  },
  methods: {
    getSlider() {
      DashboardService.getBanner("desktop_reward_page").then(res => {
        this.bannersData = res.data.data;
      });
    },
    getPage() {
      GiftsService.getPage().then(response => {
        this.giftInfoBox = response.data.data;
      });
    },
    getRewards() {
      GiftsService.rewards().then(response => {
        this.rewardData = response.data.data;
        this.giftCardLoader = false;
      });
    },
    getGifts() {
      this.loading = true;
      GiftsService.getGifts()
        .then(response => {
          this.giftTableLoader = false;
          this.giftsData = response.data;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getGiftsPerPage(page) {
      this.loading = true;
      GiftsService.getGiftsPagination(page)
        .then(response => {
          this.giftsData = response.data;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    onPageSizeChanged(item, name) {
      this.gridApi.paginationSetPageSize(Number(item));
      this.tableItemShowFirstIndex = name;
    }
  }
};
